'use strict';

export class DataRetrieverService {
  static $inject = [
    'cacheStorageService', 'authService'
  ];

  constructor(cacheStorageService, authService) {
    this.cacheStorageService = cacheStorageService;
    this.authService = authService;
  }

  cachedProxy(originalKey, cacheTime, retrieveFn) {
    let key = this.authService.getUserName() + '-' + originalKey;

    return new Promise((resolve, reject) => {
      let value = this.cacheStorageService.retrieve(key, false);
      if (value) {
        resolve(value);
      } else {
        retrieveFn().then((resp) => {
          if (cacheTime > 0) {
            this.cacheStorageService.store(key, resp, cacheTime);
          }
          resolve(resp);
        }, (err) => {
          if (err.status === 500 || err.status === 404 || err.status === 401) {
            reject(err);
            return;
          }

          let value = this.cacheStorageService.retrieve(key, true);
          if (value) {
            // indicate that we don't have up to date version of requested data
            value._offlineVersion = true;
            resolve(value);
          } else {
            reject(err);
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/dataRetriever.js